 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTFM1_TITLEPAGE from '@/components/Text/FM1_TitlePage'
 import TEXTFM2_COPYRIGHT from '@/components/Text/FM2_Copyright'
 import TEXTFM3_DEDICATION from '@/components/Text/FM3_Dedication'
 import TEXTFM4_INTRO from '@/components/Text/FM4_Intro'
 import TEXTFM5_ACKNOW from '@/components/Text/FM5_Acknow'
 import TEXTFM6_EPIGRAPH from '@/components/Text/FM6_Epigraph'
 import TEXT01_PRELUDE from '@/components/Text/01_prelude'
 import TEXT02_PART01 from '@/components/Text/02_part01'
 import TEXT03_INTERLUDE from '@/components/Text/03_interlude'
 import TEXT04_PART02 from '@/components/Text/04_part02'
 import TEXT05_EPILUDE from '@/components/Text/05_epilude'
 import LOVE_2 from '@/components/love_2'
 import TEXTBM1_AFTERWORD from '@/components/Text/BM1_Afterword'
 import TEXTBM2_FURTHERREADING from '@/components/Text/BM2_FurtherReading'
 import TEXTBM3_READINGGROUP from '@/components/Text/BM3_ReadingGroup'
 import TEXTBM4_ABA from '@/components/Text/BM4_ABA'
 import TEXTBM2_CONNECTWITHDB from '@/components/Text/BM2_ConnectWithDB'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/FM1_TitlePage",
 			"name" : "Text/FM1_TitlePage",
 			"component" : TEXTFM1_TITLEPAGE
 		},
 		{
 			"path" : "/Text/FM2_Copyright",
 			"name" : "Text/FM2_Copyright",
 			"component" : TEXTFM2_COPYRIGHT
 		},
 		{
 			"path" : "/Text/FM3_Dedication",
 			"name" : "Text/FM3_Dedication",
 			"component" : TEXTFM3_DEDICATION
 		},
 		{
 			"path" : "/Text/FM4_Intro",
 			"name" : "Text/FM4_Intro",
 			"component" : TEXTFM4_INTRO
 		},
 		{
 			"path" : "/Text/FM5_Acknow",
 			"name" : "Text/FM5_Acknow",
 			"component" : TEXTFM5_ACKNOW
 		},
 		{
 			"path" : "/Text/FM6_Epigraph",
 			"name" : "Text/FM6_Epigraph",
 			"component" : TEXTFM6_EPIGRAPH
 		},
 		{
 			"path" : "/Text/01_prelude",
 			"name" : "Text/01_prelude",
 			"component" : TEXT01_PRELUDE
 		},
 		{
 			"path" : "/Text/02_part01",
 			"name" : "Text/02_part01",
 			"component" : TEXT02_PART01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js